export default __webpack_public_path__ + "static/media/trash-bin-small.2a72ee98.svg";